<template lang="html">
  <div class="column is-4" style="display: flex;">
    <div class="ArticleList-item">
      <router-link class="ArticleList-imageContainer" :to="slug">
        <image-source
          :hotspot="image.hotspot"
          :crop="image.crop"
          :metadata="image.asset.metadata"
          :source="image.asset.url"
          :widths="widths" :ratio=1.78 :alt="title" >
        </image-source>
      </router-link>
      <div class="ArticleList-textContainer">
        <h4 class="title is-3">
          <router-link :to="slug">{{title}}</router-link>
        </h4>
        <p style="margin-bottom: 0">
          {{lead}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ImageSource from '@/components/ImageSource'

export default {
  props: ['title', 'slug', 'image', 'lead'],
  components: {
    'image-source': ImageSource
  },
  data () {
    return {
      widths: [600, 600, 800]
    }
  }
}
</script>

<style lang="css">
.ArticleList-imageContainer img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/FrontPageNewsItem.vue